import { OrderState } from './state';

export const orderInitialState: OrderState = {
  basket: []
}